export const iconFontAwesomeUsersPeopleUser = (
	<i className="fa-solid fa-user"></i>
);
